var _circle, _circle2, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTargetWishlist = function SvgTargetWishlist(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 158.58 158.58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.29,
    cy: 79.29,
    r: 79.29,
    fill: "#f0592b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.29,
    cy: 79.29,
    r: 16.8,
    fill: "#fefdfd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m79.29,127.29c-26.47,0-48-21.53-48-48s21.53-48,48-48,48,21.53,48,48-21.53,48-48,48Zm0-80.92c-18.15,0-32.92,14.77-32.92,32.92s14.77,32.92,32.92,32.92,32.92-14.77,32.92-32.92-14.77-32.92-32.92-32.92Z",
    fill: "#fefdfd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTargetWishlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/target-wishlist.056735c9.svg";
export { ForwardRef as ReactComponent };